import * as React from 'react';
import { styled } from '../../theme';
import { css } from '@emotion/react';

export const CommonInputCss = css`
  padding: 12px 18px;
  border-radius: 4px;
  outline: none;
  font-size: 14px;
  width: 100%;

  &:disabled {
    opacity: 0.6;
  }
`;

export const Input = styled.input<{ error?: boolean }>`
  ${CommonInputCss};
  border: solid 1px ${(p) => (p.error ? p.theme.forms.input.error : 'transparent')};
  background: ${(p) => p.theme.forms.input.background};
  color: ${(p) => p.theme.forms.input.color};

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px ${(p) => p.theme.forms.input.background} inset !important;
    -webkit-text-fill-color: ${(p) => p.theme.forms.input.color} !important;
  }
`;

export interface InputWrapperProps {
  label?: string;
  error?: string | JSX.Element | false;
  className?: any;
  children: React.ReactNode;
}

export const InputWrapperWidget: React.FC<InputWrapperProps> = (props) => {
  const getLabel = (): JSX.Element | null => {
    if (!props.label) {
      return null;
    }
    return <S.Label>{props.label}</S.Label>;
  };

  return (
    <S.Container className={props.className}>
      {getLabel()}
      {props.children}
      {props.error ? <S.Error>{props.error}</S.Error> : null}
    </S.Container>
  );
};

namespace S {
  export const Container = styled.div`
    flex-grow: 1;
  `;

  export const Label = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: ${(p) => p.theme.text.primary};
    padding-bottom: 8px;
  `;

  export const Error = styled.div`
    margin-top: 10px;
    color: ${(p) => p.theme.forms.input.error};
    font-size: 14px;
    user-select: text;
    & a {
      color: ${(p) => p.theme.forms.input.error};
      font-weight: bold;
      text-decoration: none;
    }
  `;
}
